module.exports = __webpack_public_path__ + "static/media/qualitas-clock.0cd0559d.svg";